import bridge from './huoli-bridge';

const ready_ = new Promise(resolve => {
  bridge.ready(() => {
    resolve();
  });
});

function ready() {
  return ready_;
}

function invoke(method, params) {
  return new Promise((resolve, reject) => {
    return bridge.invoke(method, params, (error, result) => {
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    });
  });
}

export default {
  ready: ready,
  invoke: invoke,
  on: bridge.on
};



// WEBPACK FOOTER //
// ./src/utils/nativeApi.js